import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Discount } from '../models/discount.model';
import { DiscountTotal } from '../models/discounttotal.model';

@Injectable({
    providedIn: 'root'
})
export class DiscountService {

    private apiURL : string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {
        this.apiURL = this.appConfigurationService.baseApi + '/discount';
    }

    getByEdition(editionId: number): any {

        const url = this.apiURL + '/edition/' + editionId;
        return this.http.get<Discount[]>(url);

    }

    getCodesByEdition(editionId: number): any {
        const url = this.apiURL + '/codesByEdition/' + editionId;
        return this.http.get<DiscountTotal[]>(url);

    }

}
